import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  LeaderboardEntry,
  LeaderboardMappedResult,
} from '@/core/interfaces';

interface LeaderboardState {
  leaderboard: LeaderboardEntry[];
  totalTapPoints: number;
  userRank:number;
}

const initialState: LeaderboardState = {
  leaderboard: [],
  totalTapPoints: 0,
  userRank:0,
};

const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    setLeaderboardData: (
      state,
      action: PayloadAction<LeaderboardMappedResult>
    ) => {
        state.leaderboard = [...action.payload.leaderboard].sort((a, b) => b.points - a.points);
        state.totalTapPoints = action.payload.totalTapPoints;
        state.userRank =action.payload.userRank;
    },
    clearLeaderboard: (state) => {
      state.leaderboard = [];
      state.totalTapPoints = 0;
      state.userRank =0;
    },
  },
});

const { reducer, actions } = leaderboardSlice;

export const { setLeaderboardData, clearLeaderboard } = actions;
export default reducer;